import { useEffect } from 'react'

import { getSessionDefaults } from 'data/api'

import useCatalogContext from '../CatalogProvider/useCatalogContext'
import { ConfigurationReducerAction } from '../CatalogProvider/reducers/actionTypes'

const useFetchCatalogConfigurations = () => {
  const { dispatch } = useCatalogContext()

  useEffect(() => {
    const fetchConfiguration = async () => {
      dispatch({ type: ConfigurationReducerAction.FETCH_CONFIG_REQUEST, payload: undefined })

      const response = await getSessionDefaults()

      if ('errors' in response) {
        dispatch({ type: ConfigurationReducerAction.FETCH_CONFIG_FAILURE, payload: undefined })
      } else {
        dispatch({
          type: ConfigurationReducerAction.FETCH_CONFIG_SUCCESS,
          payload: response.session_defaults_configuration,
        })
      }
    }

    fetchConfiguration()
  }, [dispatch])
}

export default useFetchCatalogConfigurations
